import { getSubStepValues } from '#models/general/steps';
import Checkbox from '#components/general/Checkbox';
import Input from '#components/general/Input';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';
import { getSelectField } from '#utils/select';

import { MILLING_FIELDS, MASH_SUBSTEPS_IDS, PEATED_OPTIONS } from './constants';

export const getMillingFields = ({ values, errors }) => {
  const getMillingValues = getSubStepValues(MASH_SUBSTEPS_IDS.MILLING, values, errors);
  return [
    {
      ...getMillingValues(MILLING_FIELDS.START_DATE_AND_TIME),
      Component: Input,
      type: 'datetime-local'
    },
    {
      key: 'firstAndSecondMaltBinNo',
      Component: AdelphiFieldsRow,
      fields: [
        {
          ...getMillingValues(MILLING_FIELDS.FIRST_MALT_BIN_NO),
          Component: Input,
          needsRegex: true
        },
        {
          ...getMillingValues(MILLING_FIELDS.SECOND_MALT_BIN_NO),
          Component: Input,
          needsRegex: true
        }
      ]
    },
    getSelectField({
      field: MILLING_FIELDS.FIRST_MALT_BIN_PEATED,
      substep: MASH_SUBSTEPS_IDS.MILLING,
      manualField: MILLING_FIELDS.FIRST_MALT_BIN_PEATED_MANUAL,
      values,
      options: PEATED_OPTIONS,
      getValues: getMillingValues
    }),
    getSelectField({
      field: MILLING_FIELDS.SECOND_MALT_BIN_PEATED,
      substep: MASH_SUBSTEPS_IDS.MILLING,
      manualField: MILLING_FIELDS.SECOND_MALT_BIN_PEATED_MANUAL,
      values,
      options: PEATED_OPTIONS,
      getValues: getMillingValues
    }),
    {
      ...getMillingValues(MILLING_FIELDS.GRIST_ANALYSIS),
      Component: Checkbox
    },
    ...(values[MILLING_FIELDS.GRIST_ANALYSIS]
      ? [
          {
            key: 'huskAndGristRatio',
            Component: AdelphiFieldsRow,
            fields: [
              {
                ...getMillingValues(MILLING_FIELDS.HUSK_RATIO),
                Component: Input,
                needsRegex: true,
                measure: MEASURE_TYPES.PERCENTAGE
              },
              {
                ...getMillingValues(MILLING_FIELDS.GRIST_RATIO),
                key: MILLING_FIELDS.GRIST_RATIO,
                Component: Input,
                needsRegex: true,
                measure: MEASURE_TYPES.PERCENTAGE
              }
            ]
          },
          {
            ...getMillingValues(MILLING_FIELDS.FLOUR_RATIO),
            key: MILLING_FIELDS.FLOUR_RATIO,
            Component: Input,
            needsRegex: true,
            measure: MEASURE_TYPES.PERCENTAGE
          }
        ]
      : []),
    {
      ...getMillingValues(MILLING_FIELDS.FAILURE),
      Component: Input
    }
  ];
};
